export default {"src":"/_next/static/media/bucket-purple.73f0c345.svg","height":16,"width":17};